import type { AgentTurnResult } from "./agentChatState";

export type AgentProgressStepStatus = "done" | "running" | "failed" | "stopped";

export interface AgentProgressStep {
  text: string;
  status: AgentProgressStepStatus;
}

const TRAILING_ELLIPSIS = /(?:\.{3}|…)$/;

const getLastStepStatus = (turnStatus: AgentTurnResult["status"]): AgentProgressStepStatus => {
  switch (turnStatus) {
    case "running":
      return "running";
    case "failed":
      return "failed";
    case "stopped":
      return "stopped";
    default:
      return "done";
  }
};

export const toProgressSteps = (progress: string[], turnStatus: AgentTurnResult["status"]): AgentProgressStep[] =>
  progress.map((text, index) => {
    const status = index === progress.length - 1 ? getLastStepStatus(turnStatus) : "done";
    return { text: status === "running" ? text : text.replace(TRAILING_ELLIPSIS, ""), status };
  });

export const formatElapsed = (milliseconds: number): string => {
  const totalSeconds = Math.max(0, Math.floor(milliseconds / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return minutes === 0 ? `${seconds}s` : `${minutes}m ${seconds}s`;
};

export const describeFinishedProgress = (elapsedMilliseconds: number, stepCount: number): string => {
  const worked = `Worked for ${formatElapsed(elapsedMilliseconds)}`;
  if (stepCount === 0) {
    return worked;
  }
  return `${worked} · ${stepCount} ${stepCount === 1 ? "step" : "steps"}`;
};
